import type { MappedOperator } from "@busbud/int-schemas/udm";

import type { NapiV2Purchase } from "@app/types/napi-v2-purchase-types";

export function getPurchaseTripOperator(
  purchase: NapiV2Purchase
): MappedOperator {
  // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  return Object.values(purchase.trips)[0].segments[0].operator;
}
